import type { ReactNode } from 'react';
import styles from './ui.module.css';

export function Spinner() {
  return <span className={styles.spinner} role="status" aria-label="Ładowanie" />;
}

export function LoadingBlock() {
  return (
    <div className={styles.center}>
      <Spinner />
    </div>
  );
}

export function EmptyState({
  title,
  description,
  mark = '✓',
  children,
}: {
  title: string;
  description?: string;
  mark?: string;
  children?: ReactNode;
}) {
  return (
    <div className={styles.empty}>
      <div className={styles.emptyMark} aria-hidden="true">
        {mark}
      </div>
      <p className={styles.emptyTitle}>{title}</p>
      {description && <p className={styles.emptyText}>{description}</p>}
      {children}
    </div>
  );
}

export function ErrorBox({ children }: { children: ReactNode }) {
  return (
    <div className={styles.errorBox} role="alert">
      <span aria-hidden="true">⚠</span>
      <span>{children}</span>
    </div>
  );
}

export function Panel({
  title,
  action,
  children,
}: {
  title: string;
  action?: ReactNode;
  children: ReactNode;
}) {
  return (
    <section className={styles.panel}>
      <header className={styles.panelHeader}>
        <h3 className={styles.panelTitle}>{title}</h3>
        {action}
      </header>
      <div className={styles.panelBody}>{children}</div>
    </section>
  );
}
